import React from "react";
import axios from "axios";
import { useEffect, useState } from "react";
import SolutionBy from "../Components/SolutionBy";
import { useFont } from "../contexts/FontContext";
import Page from "../Components/Page";

const SolutionByGoal = () => {
  const [, setError] = useState(null);
  const [goaldata, setgoaldata] = useState([]);
  const fontValue = useFont();
  const font = fontValue?.font;

  useEffect(() => {
    axios
      .get(process.env.REACT_APP_STRAPI_API_URL + "/api/byyg?populate=*")
      .then(({ data }) => setgoaldata(data.data.attributes))
      .catch((error) => setError(error));
  }, []);

  return (
    <Page isLoading={fontValue?.loading}>
      <div id="SolutionbyYourGoals&Needs">
        <SolutionBy
          font={font}
          solutionData={{
            SUHTX_01: goaldata.BYYG_SUHTX_01,
            CATHTX_1: goaldata.CATHTX_4,
            BY1_HDTX_01: goaldata.BYYG1_HDTX_01,
            BY1_IMG_01A: goaldata.BYYG1_IMG_01A?.data?.attributes?.url,
            BY1_IMG_01B: goaldata.BYYG1_IMG_01B?.data?.attributes?.url,
            BY1_DTX_01A: goaldata.BYYG1_DTX_01A,
            BY2_HDTX_01: goaldata.BYYG2_HDTX_01,
            BY2_IMG_01A: goaldata.BYYG2_IMG_01A?.data?.attributes?.url,
            BY2_IMG_01B: goaldata.BYYG2_IMG_01B?.data?.attributes?.url,
            BY2_DTX_02A: goaldata.BYYG2_DTX_01A,
            BY3_HDTX_01: goaldata.BYYG3_HDTX_01,
            BY3_IMG_01A: goaldata.BYYG3_IMG_01A?.data?.attributes?.url,
            BY3_IMG_01B: goaldata.BYYG3_IMG_01B?.data?.attributes?.url,
            BY3_DTX_03A: goaldata.BYYG3_DTX_01A,
            BY4_HDTX_01: goaldata.BYYG4_HDTX_01,
            BY4_IMG_01A: goaldata.BYYG4_IMG_01A?.data?.attributes?.url,
            BY4_IMG_01B: goaldata.BYYG4_IMG_01B?.data?.attributes?.url,
            BY4_DTX_04A: goaldata.BYYG4_DTX_01A,
          }}
          type={"RL"}
        />
      </div>
    </Page>
  );
};

export default SolutionByGoal;
